import { Controller } from "@hotwired/stimulus";

// Attached to the staff bundle edit form on an approved bundle.
// Compares initial bundle values with edited values and if name, visibility,
// or access is changed, shows a confirmation dialog to the user.
export default class extends Controller {
  static values = {
    confirmMessage: String,
  };

  connect() {
    this.initial = this.snapshot();
    this.boundHandleSubmit = this.handleSubmit.bind(this);
    this.element.addEventListener("submit", this.boundHandleSubmit);
  }

  disconnect() {
    this.element.removeEventListener("submit", this.boundHandleSubmit);
  }

  handleSubmit(event) {
    if (!this.hasRelevantChange()) return;
    if (!window.confirm(this.confirmMessageValue)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  snapshot() {
    return {
      name: this.value("nu_bundle[nu_name]"),
      visibility: this.checkedValue("nu_bundle[nu_is_public]"),
      users: this.selectedValues("nu_bundle[nu_users][]"),
    };
  }

  hasRelevantChange() {
    const current = this.snapshot();
    return (
      current.name !== this.initial.name ||
      current.visibility !== this.initial.visibility ||
      current.users.join(",") !== this.initial.users.join(",")
    );
  }

  value(name) {
    return this.element.querySelector(`[name="${name}"]`)?.value ?? "";
  }

  checkedValue(name) {
    return this.element.querySelector(`[name="${name}"]:checked`)?.value ?? "";
  }

  selectedValues(name) {
    const select = this.element.querySelector(`select[name="${name}"]`);
    return Array.from(select?.selectedOptions ?? [])
      .map((o) => o.value)
      .sort();
  }
}
